import deviceUtils from '@src/utils/device-utils';
import { noop } from '@src/utils/common-util';

(function () {
  window.AudioContext = window.AudioContext || window.webkitAudioContext;
  if (window.AudioContext) {
    window.audioContext = new window.AudioContext();
  }
  var fixAudioContext = function (e) {
    if (window.audioContext) {
      // Create empty buffer
      var buffer = window.audioContext.createBuffer(1, 1, 22050);
      var source = window.audioContext.createBufferSource();
      source.buffer = buffer;
      // Connect to output (speakers)
      source.connect(window.audioContext.destination);
      // Play sound
      if (source.start) {
        source.start(0);
      } else if (source.play) {
        source.play(0);
      } else if (source.noteOn) {
        source.noteOn(0);
      }
    }
    // Remove events
    document.removeEventListener('touchstart', fixAudioContext);
    document.removeEventListener('touchend', fixAudioContext);
  };
  // iOS 6-8
  document.addEventListener('touchstart', fixAudioContext);
  // iOS 9
  document.addEventListener('touchend', fixAudioContext);
})();

function playIOSAudio(src) {
  const path = src;
  const context = window.audioContext;
  const request = new XMLHttpRequest();
  request.open('GET', path, true);
  request.responseType = 'arraybuffer';
  request.addEventListener(
    'load',
    function (e) {
      context.decodeAudioData(this.response, function (buffer) {
        var source = context.createBufferSource();
        source.buffer = buffer;
        source.connect(context.destination);
        source.start(0);
        audioInUsePool.push(source);
        source.onended = () => {
          audioInUsePool = audioInUsePool.filter(_source => _source !== source);
        };
      });
    },
    false
  );
  request.send();
}

function playAudio(src, { audio, loop = false } = {}) {
  if (deviceUtils.isIOS()) {
    pauseAllAudioFromAudioInUsePool();
    playIOSAudio(src);
    return;
  }

  if (!audio) {
    audio = getAudioFromInUsePool();
  }
  if (audio) audio.src = src;
  audio.loop = loop;
  pauseAllAudioFromAudioInUsePool();
  const playPromise = audio.play();
  if (playPromise !== undefined) {
    playPromise.catch(f => f);
  }
  return audio;
}

let audioInUsePool = [];

function getAudioFromInUsePool(audio = getAudioFromFreePool()) {
  if (!audio.__pause__) {
    audio.__pause__ = true;
    audio.addEventListener('pause', () => {
      audio.src = '';
      audioInUsePool = audioInUsePool.filter(audioItem => audioItem !== audio);
      audioFreePool.push(audio);
    });
  }

  if (!audio.__ended__) {
    audio.__ended__ = true;
    audio.addEventListener('ended', () => {
      audio.src = '';
      audioInUsePool = audioInUsePool.filter(audioItem => audioItem !== audio);
      audioFreePool.push(audio);
    });
  }
  audioInUsePool.push(audio);
  return audio;
}

function pauseAllAudioFromAudioInUsePool() {
  audioInUsePool.forEach(audio => {
    // TODO: 这里可能使用 stop 更好， 先使用 pause 进行测试
    if (audio.stop) {
      audio.stop();
    } else {
      audio.pause();
    }
  });
}

const audioFreePool = [new Audio(), new Audio(), new Audio()];

function getAudioFromFreePool() {
  if (audioFreePool.length) {
    return audioFreePool.pop();
  } else {
    return new Audio();
  }
}

function playAudioHOF(src, loop = false) {
  return () => playAudio(src, loop);
}

export const playTakePhotoAudio = playAudioHOF(require('./audios/take-photo.mp3'));

export const getBackgroundMusic = function ({ src, loop = true, autoplay = false, playCb = noop, endedCb = noop }) {
  const audio = new Audio();
  audio.loop = loop;
  audio.src = src;
  audio.addEventListener('playing', function () {
    console.log('playing');
    playCb();
  });
  audio.addEventListener('ended', function () {
    console.log('ended');
    endedCb();
  });
  const action = {
    audio: audio,
    play: (restart = true) => {
      if (restart) {
        action.stop();
      }
      // noinspection JSIgnoredPromiseFromCall
      audio.play();
      return audio;
    },
    pause: () => {
      audio.pause();
      return audio;
    },
    stop: () => {
      action.pause();
      audio.currentTime = 0;
      return audio;
    }
  };
  return action;
};
/**
 * 获取背景音乐
 * 用法：
 * 重新播放：backgroundMusic.play()
 * 继续上一次进度播放：backgroundMusic.play(false)
 * 暂停：backgroundMusic.pause()
 * 停止：backgroundMusic.stop()
 */
